import { ApolloClient, InMemoryCache } from '@apollo/client'

const cache = new InMemoryCache()

const apClient = new ApolloClient({
  uri: 'https://api-eu-west-2.graphcms.com/v2/cl3zz175o1try01w6hquu7oin/master',
  cache,
});

export default apClient;